<template>
  <div class="info">
    <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
      layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
      :current-page.sync="page.currentPage" :page-size="page.pageSize" @selection-change="onMultipleSelection"
      @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
    </lb-table>
  </div>
</template>
<script>
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    LbTable
  },
  props: {
    userId: Number
  },
  data() {
    return {
      name: 'cdd',
      list: [],
      columns: [
        { label: '订单编号', prop: 'orderNo', minWidth: '200' },
        { label: '收货人姓名', prop: 'userName', minWidth: '220' },
        { label: '收货人电话', prop: 'phone', minWidth: '120' },
        { label: '下单时间', prop: 'orderTime', minWidth: '200' },
        {
          label: '订单金额/积分', prop: 'orderPrice', minWidth: '120',
          render: (h, scope) => {
            let vv = ''
            if (scope.row.typeLabel == '积分订单') {
              vv = <p>
                <div>{scope.row.costPoints}</div>
              </p>
            } else {
              vv = <p>
                <div>{scope.row.orderPrice}</div>
              </p>
            }
            return (
              <div> {vv}</div>

            )
          }
        },
        {
          label: '订单状态', prop: 'statusLabel', minWidth: '120',
          // render: (h, scope) => {
          //   let vv = ''
          //   if (scope.row.statusLabel == '已收货') {
          //     vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center"><div style="width: 10px;height: 10px;background: #13CE4B;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
          //       <div>{scope.row.statusLabel}</div>
          //     </p>
          //   } else if (scope.row.statusLabel == '待发货') {
          //     vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center"><div style="width: 10px;height: 10px;background: #FF9226;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
          //       <div>{scope.row.statusLabel}</div>
          //     </p>
          //   } else if (scope.row.statusLabel == '待收货') {
          //     vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center"><div style="width: 10px;height: 10px;background: #FF9226;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
          //       <div>{scope.row.statusLabel}</div>
          //     </p>
          //   } else if (scope.row.statusLabel == '售后') {
          //     vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center"><div style="width: 10px;height: 10px;background: #F63C56;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
          //       <div>{scope.row.statusLabel}</div>
          //     </p>
          //   } else {
          //     vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center"><div style="width: 10px;height: 10px;background:  #C0C0CC;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
          //       <div>{scope.row.statusLabel}</div>
          //     </p>
          //   }
          //   return (
          //     <div> {vv}</div>

          //     // <p style="color:#303033;font-size:14px;">{scope.row.verifyStatusLabel}</p>
          //   )
          // }
        },
        { label: '订单类型', prop: 'typeLabel', minWidth: '120' },
        {
          label: '操作',
          minWidth: '120',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.todetail(scope.row) }}>查看</span>
              </div>
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' }
    }
  },
  created() {
    this.getOrderPageList()
    console.log(this.userId)
  },
  watch: {
    userId: {
      handler(val, oldVal) {
        console.log(val, oldVal)
        this.userId = val
        this.page.pageNo = 1;
        this.getOrderPageList()
      }
    }
  },
  methods: {
    todetail(row) {
      let query = {}
      let name = 'logisticsOrderDetail'
      // if (row.statusLabel == '售后') {
      //   name = 'afterOrderDetail'
      // } else {
      //   name = 'logisticsOrderDetail'
      // }

      query = { orderNo: row.orderNo, orderId: row.id, id: row.id, }
      this.$router.push({ name, query })
    },
    onMultipleSelection(e) { },
    handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNo = 1;
      this.getOrderPageList()
    },
    handleCurrentChange(e) {
      this.page.pageNo = e;
      this.getOrderPageList()
    },
    getOrderPageList() {
      let data = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        id: this.userId
      }
      this.axios.post('/user/userInfo/order', data)
        .then(res => {
          if (res.code == 0) {
            this.list = res.data.list;
            this.page.totalNum = res.data.totalNum;
          }
        })
    }
  }
}
</script>
<style scoped lang="scss">
.info {
  padding-top: 20px;
  padding-bottom: 20px;

  /deep/ .el-table .el-table__header .el-table__cell {
    padding: 0;
  }

  /deep/ .el-table .el-table__row .el-table__cell {
    color: #303033;
    font-weight: 400;
  }
}
</style>

